/**
 * SC Icon Directive
 *
 * @example <sc-svg-inline name="trustwave" svg-fill="red" svg-width="500" svg-height="500"></sc-svg-inline>
 * @description Reusable svg icon directive
 * @namespace Core
 * @memberof TR
 */

'use strict';

namespace Core {

    class ScSvgInline implements ng.IDirective {

        restrict: string;
        replace: boolean;
        template: string;
        scope: object;

        constructor() {

            this.restrict = 'E';
            this.scope = {
                name: '@',
                svgWidth: '@',
                svgHeight: '@',
                svgFill: '@',
                class: '@',
                path: '@'
            };
            this.replace = true;
            this.template = '<span ng-include="svgInline" onload="callback()"></span>';
        }

        setSvgAttributes = (el, scope) => {
            scope.svgHeight ? el.attr('height', scope.svgHeight) : null;
            scope.svgWidth ? el.attr('width', scope.svgWidth) : null;
            scope.svgFill ? el.attr('fill', scope.svgFill) : null;
            scope.class ? el.addClass(scope.class) : null;
            el.unwrap();
        }

        link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
            const path = scope.path ? scope.path : '/build/fonts/sandcastle-icons/svgs';
            const url = `${path}/${attrs.name}.svg`;
            scope.svgInline = url;

            scope.callback = () => {
                const parent = element[0].nextSibling;
                if (parent !== null && parent instanceof Element) {
                    const childEl:any = parent.querySelector('svg');
                    const child:any = angular.element(childEl);
                    const el = angular.element(child);
                    this.setSvgAttributes(el, scope);
                }
            };
        }

        static factory(): ng.IDirectiveFactory {
            const directive = () => new ScSvgInline();
            directive.$inject = [];
            return directive;
        }

    }

    const TR = angular.module('TR');
    TR.directive('scSvgInline', ScSvgInline.factory());
}
